
import axios, { AxiosResponse } from 'axios';

export interface CartItem {
  id?: number;
  user_id?: number | undefined;
  sku?: string;
  quantity: number | null;
  order_reference?: string;
  available_stock: number | null;
  principle?: string;
  status: string;
  created_at?: string;
  updated_at?: string;
}

export interface CartItemForDB {
  user_id?: number; 
  sku?: string;
  quantity?: number;
  order_date: string;
  order_reference: string;
  available_stock: number | null;
  principle: string;
  status: string;
  item_quantity:number;
  is_machine?:boolean;
  is_black?:boolean

}


const API_URL = 'https://sodastreamapi.azurewebsites.net/cart';

class CartService {

  async getProductByItemCodes(order_reference: string): Promise<{ data: any | null; error: string | null }> {
    try {
      const response: AxiosResponse<any> = await axios.get(`${API_URL}/products/${order_reference}`);
      
      if (response.status >= 200 && response.status < 300) {
        return { data: response.data, error: null };
      } else {
        const error = "Error fetching product by SKU";
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error fetching product by SKU:", error.message);
      return { data: null, error: error.message };
    }
  }
  

  async getItemByOrderReference(
    order_reference: string
  ): Promise<{ data: CartItem | null; error: string | null }> {
    try {
      const response: AxiosResponse<CartItem> = await axios.get(
        `${API_URL}/cart/items/${order_reference}`
      );
      if (response.status >= 200 && response.status < 300) {
        const items: CartItem = response.data;

        return { data: items, error: null };
      } else {
        const error = "Error fetching item by order reference";
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error fetching item by order reference:", error);
      return { data: null, error };
    }
  }

  async removeFromCart(order_reference: string): Promise<{ data?: string; error?: string }> {
    try {
        const response: AxiosResponse<{ message: string }> = await axios.delete(
            `${API_URL}/remove/${order_reference}`
        );

        if (response.status >= 200 && response.status < 300) {
            return { data: response.data.message };
        } else {
            const error = 'Error removing items from cart';
            console.error(error);
            return { error };
        }
    } catch (error: any) {
        console.error('Error removing items from cart:', error.message);
        return { error: error.message };
    }
}


  async addToCart(cartItem: CartItemForDB): Promise<{ data: CartItemForDB | null; error: string | null }> 
  {
    try {
      const response: AxiosResponse<CartItemForDB > = await axios.post(`${API_URL}/add`, cartItem);
      if (response.status >= 200 && response.status < 300) {
        return { data: response.data, error: null };
      } else {
        const error = 'Error adding item to cart';
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error('Error adding item to cart:', error.message);
      return { data: null, error: error.message };
    }
  }

  async updateCartItem(cartItem: CartItemForDB ): Promise<{ data: CartItemForDB | null; error: string | null }> {

    try {
      const response: AxiosResponse<{ message: string; cartItem: CartItemForDB  }> = await axios.put(`${API_URL}/update`, cartItem);
      if (response.status >= 200 && response.status < 300) {
        return { data: response.data.cartItem, error: null };
      } else {
        const error = 'Error updating cart item';
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error('Error updating cart item:', error.message);
      return { data: null, error: error.message };
    }
  }

  async updateUserIdByOrderReference(order_reference: string, user_id: number): Promise<{ data: CartItem[] | null; error: string | null }> {
    try {
      const response: AxiosResponse<{ message: string; updatedItems: CartItem[] }> = await axios.put(`${API_URL}/update-user-id`, { order_reference, user_id });
      if (response.status >= 200 && response.status < 300) {
        return { data: response.data.updatedItems, error: null };
      } else {
        const error = 'Error updating user ID by order reference';
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error('Error updating user ID by order reference:', error.message);
      return { data: null, error: error.message };
    }
  }

}

const cartServiceInstance = new CartService();
export default cartServiceInstance;






// import axios, { AxiosResponse } from 'axios';


// export interface CartItem {
//   id?: number;
//   user_id: string;
//   sku: string;
//   quantity: number;
//   order_reference?: string;
//   available_stock?: number;
//   principle?: string;
//   status?: string;
//   created_at?: string;
//   updated_at?: string;
// }

// const API_URL = 'https://sodastreamapi.azurewebsites.net/cart';

// class CartService {
//   async addToCart(cartItem: Omit<CartItem, 'id' | 'created_at' | 'updated_at'>): Promise<{ data: CartItem | null; error: string | null }> {
//     try {
//       const response: AxiosResponse<CartItem> = await axios.post(`${API_URL}/add`, cartItem);
//       if (response.status >= 200 && response.status < 300) {
//         return { data: response.data, error: null };
//       } else {
//         const error = 'Error adding item to cart';
//         console.error(error);
//         return { data: null, error };
//       }
//     } catch (error: any) {
//       console.error('Error adding item to cart:', error.message);
//       return { data: null, error: error.message };
//     }
//   }

//   async getCartItems(userId: string): Promise<{ data: CartItem[] | null; error: string | null }> {
//     try {
//       const response: AxiosResponse<{ cartItems: CartItem[] }> = await axios.get(`${API_URL}/items/${userId}`);
//       if (response.status >= 200 && response.status < 300) {
//         return { data: response.data.cartItems, error: null };
//       } else {
//         const error = 'Error fetching cart items';
//         console.error(error);
//         return { data: null, error };
//       }
//     } catch (error: any) {
//       console.error('Error fetching cart items:', error.message);
//       return { data: null, error: error.message };
//     }
//   }

//   async getAllCartItems(): Promise<{ data: CartItem[] | null; error: string | null }> {
//     try {
//       const response: AxiosResponse<{ cartItems: CartItem[] }> = await axios.get(`${API_URL}/items`);
//       if (response.status >= 200 && response.status < 300) {
//         return { data: response.data.cartItems, error: null };
//       } else {
//         const error = 'Error fetching all cart items';
//         console.error(error);
//         return { data: null, error };
//       }
//     } catch (error: any) {
//       console.error('Error fetching all cart items:', error.message);
//       return { data: null, error: error.message };
//     }
//   }

//   async updateCartItem(id: number, data: Partial<CartItem>): Promise<{ data: CartItem | null; error: string | null }> {
//     try {
//       const response: AxiosResponse<CartItem> = await axios.put(`${API_URL}/item/${id}`, data);
//       if (response.status >= 200 && response.status < 300) {
//         return { data: response.data, error: null };
//       } else {
//         const error = 'Error updating cart item';
//         console.error(error);
//         return { data: null, error };
//       }
//     } catch (error: any) {
//       console.error('Error updating cart item:', error.message);
//       return { data: null, error: error.message };
//     }
//   }

//   async removeCartItem(id: number): Promise<{ data: { message?: string } | null; error: string | null }> {
//     try {
//       const response: AxiosResponse<{ message?: string }> = await axios.delete(`${API_URL}/item/${id}`);
//       if (response.status >= 200 && response.status < 300) {
//         return { data: response.data, error: null };
//       } else {
//         const error = `Error removing item from cart with ID: ${id}`;
//         console.error(error);
//         return { data: null, error };
//       }
//     } catch (error: any) {
//       console.error('Error removing item from cart:', error.message);
//       return { data: null, error: error.message };
//     }
//   }

//   async clearCart(userId: string): Promise<{ data: { message?: string } | null; error: string | null }> {
//     try {
//       const response: AxiosResponse<{ message?: string }> = await axios.delete(`${API_URL}/items/${userId}`);
//       if (response.status >= 200 && response.status < 300) {
//         return { data: response.data, error: null };
//       } else {
//         const error = `Error clearing cart for user: ${userId}`;
//         console.error(error);
//         return { data: null, error };
//       }
//     } catch (error: any) {
//       console.error('Error clearing cart:', error.message);
//       return { data: null, error: error.message };
//     }
//   }
// }

// const cartServiceInstance = new CartService();
// export default cartServiceInstance;